module.exports = __webpack_public_path__ + "img/14.8da77655.jpg";